export const ErrorReporterDomain = {
	SPORTSBOOK: 'sportsbook',
	CASINO: 'casino',
	LIVE_CASINO: 'live-casino',
	WESPIN: 'wespin',
	AUTHENTICATION: 'authentication',
	ACCOUNT: 'account',
	PAYMENT: 'payment',
	SPLASHTECH: 'splashtech',
	THUNDERBITE: 'thunderbite',
	INSPIRED: 'inspired',
	UNKNOWN: 'unknown',
	API: 'api'
} as const;

export type ErrorReporterDomain = (typeof ErrorReporterDomain)[keyof typeof ErrorReporterDomain];
